import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

const pressureIcon: IconManifest = {
    id: 'pressure-icon',
    width: 128,
    height: 128,
    d: 'M45.29 16h.012a8.33 8.33 0 0 1 5.213 1.84 100.873 100.873 0 0 1 18.033 18.75 5.333 5.333 0 1 1-8.577 6.341 90.22 90.22 0 0 0-9.341-10.745v55.518a5.333 5.333 0 0 1-10.667 0V32.186a90.21 90.21 0 0 0-9.34 10.745 5.333 5.333 0 1 1-8.578-6.34 100.875 100.875 0 0 1 18.04-18.756A8.33 8.33 0 0 1 45.29 16Zm37.933 18.963a5.333 5.333 0 0 1 5.333 5.333v55.518a90.21 90.21 0 0 0 9.34-10.745 5.333 5.333 0 1 1 8.578 6.34 100.874 100.874 0 0 1-18.04 18.756A8.326 8.326 0 0 1 83.229 112h-.005a8.334 8.334 0 0 1-5.213-1.835m0-.001A100.857 100.857 0 0 1 59.97 91.41a5.333 5.333 0 1 1 8.578-6.341 90.2 90.2 0 0 0 9.341 10.745V40.296a5.333 5.333 0 0 1 5.334-5.333',
};

export function PressureIcon(props: IconBaseProps) {
    const { id, d } = pressureIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="PressureIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
